import axios from 'axios';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/season/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/season/';

class SeasonService {

  getAllSimilaritySeasons() {
    return axios.get(API_URL  + 'similarity');
  }

  getAllPlayersFromSeason(leagueId, year) {
    return axios.get(API_URL  + 'players/league/' + leagueId + '/year/' + year);
  }

  getSeasonsByLeaguesAndYears(leagueIds, years) {
    return axios.get(API_URL  + 'leagues/' + leagueIds + '/years/' + years);
  }

  getTableBySeason(leagueId,year) {
    return axios.get(`${API_URL}table/${leagueId}/${year}`);
  }

  getSeasonTeamStatsByLeaguesAndYears(templateId, leagueIds, years, isTotal) {
    return axios.get(`${API_URL}stats/table/${templateId}/league/${leagueIds}/years/${years}/${isTotal}`);
  }

  getSeasonTeamStatsByMatchDay(templateId, leagueId, year, isTotal, fromMatchDay, toMatchDay) {
    return axios.get(`${API_URL}stats/table/template/${templateId}/league/${leagueId}/year/${year}/total/${isTotal}/fromMatchDay/${fromMatchDay}/toMatchDay/${toMatchDay}`);
  }

  getSeasonAvgStats(seasonId){
    return axios.get(`${API_URL}${seasonId}/average-stats`);
  }

  getSeasonAvgPDStats(seasonId){
    return axios.get(`${API_URL}${seasonId}/average-pd-stats`);
  }

  getSeasonTeamStatsPD(seasonId, teamId){
    return axios.get(`${API_URL}${seasonId}/team/${teamId}/stats-pd`);
  }

  getSeasonsByTeam(teamId){
    return axios.get(`${API_URL}team/${teamId}`);
  }

  getRadarSeasonsOfTeam(teamId){
    return axios.get(`${API_URL}radar/team/${teamId}`);
  }

  getTeamsBySeason(seasonId) {
    return axios.get(`${API_URL}${seasonId}/teams`);
  }

  getTeamsOfSeasons(seasonIds) {
    return axios.get(`${API_URL}teams/${seasonIds}`);
  }

  getTeamsBySeasonIds(seasonIds) {
    return axios.get(`${API_URL}${seasonIds}/s/teams`);
  }

  getSeasonSubstitutions(seasonId) {
    return axios.get(`${API_URL}${seasonId}/substitutions`);
  }

  getGamesByLeagueAndYear(leagueId,year) {
    return axios.get(`${API_URL}${leagueId}/${year}/games`);
  }

  getCompetitions(seasonId) {
    return axios.get(`${API_URL}${seasonId}/competitions`);
  }

  getLeagueTable(seasonId) {
    return axios.get(`${API_URL}${seasonId}/league-table`);
  }

  getLeagueTableByYear(leagueId,year) {
    return axios.get(`${API_URL}${leagueId}/${year}/league-table`);
  }

  getSeasonsByLeagues(leagueIds, maxYearsVisible) {
    return axios.get(API_URL  + 'leagues/' + leagueIds + '/years-visible/' + maxYearsVisible);
  }

  getAvailablePhysicalSeasons(clientId) {
    return axios.get(API_URL  + 'available-physical-seasons/' + clientId);
  }

  getAvailableArrigoSeasons(clientId) {
    return axios.get(API_URL + 'available-arrigo-seasons/' + clientId);
  }

  getAvaialableArrigoSeasonsOfATeam(clientId, teamId, productIds) {
    return axios.get(API_URL + `team/${teamId}/available-seasons/${clientId}/product/${productIds}`)
  }

  getSpatialCoverage(seasonId) {
    return axios.get(`${API_URL}${seasonId}/spatial-coverage`);
  }

  getAreaSpatialCoverage(seasonId) {
    return axios.get(`${API_URL}${seasonId}/area/spatial-coverage`);
  }

  getAllTimeAvgPD() {
    return axios.get(`${API_URL}all-time-avg-pd`);
  }

  postSeason(season) {
    return axios.post(`${API_URL}`,season);
  }

  getLBPEventsBySeasonAndTeam(seasonId, teamId){
    return axios.get(API_URL + `${seasonId}/team-lbp-events/${teamId}`);
  }

  getLBPEventsBySeasonAndPlayer(seasonId, playerId){
    return axios.get(API_URL + `${seasonId}/player-lbp-events/${playerId}`);
  }

  getOnBallPressureEventsBySeasonAndTeam(seasonId, teamId){
    return axios.get(API_URL + `${seasonId}/team-on-ball-pressure-events/${teamId}`);
  }

  getOnBallPressureEventsBySeasonAndPlayer(seasonId, playerId){
    return axios.get(API_URL + `${seasonId}/player-on-ball-pressure-events/${playerId}`);
  }

  getPassesUnderPressure(seasonId, matchId = -1, teamId = -1, playerId = -1) {
    const params = {};
    
    params.matchId = matchId;
    params.teamId = teamId;
    params.playerId = playerId;
    return axios.get(`${API_URL}${seasonId}/passes-under-pressure`, { params });
  }

  getBallReceiptsInSpaceEventsBySeasonAndTeam(seasonId, teamId){
    return axios.get(API_URL + `${seasonId}/team-ball-receipts-in-space-events/${teamId}`);
  }

  getBallReceiptsInSpaceEventsBySeasonAndPlayer(seasonId, playerId){
    return axios.get(API_URL + `${seasonId}/player-ball-receipts-in-space-events/${playerId}`);
  }

  getSeasonsByTeamSimplified(teamId) {
    return axios.get(`${API_URL}team/${teamId}/simplified`);
  }

  getGamesPlayedOfTheCurrentSeason(seasonId) {
    return axios.get(`${API_URL}${seasonId}/games-played`);
  }
}

export default new SeasonService();